import { useUserRoles } from '@anytag/auth';
import { Maybe, TiktokAdvertiserSummaryData, useTiktokAdvertiserSummaryDataQuery } from '@anytag/graphql';
import { getToken } from '@anytag/router';

export interface TikTokSummaryDataContext {
  summaryData?: Maybe<TiktokAdvertiserSummaryData>;
  loading?: boolean;
}

export const useTikTokAdvertiserSummaryData = () => {
  const { isAdvertiserFromTikTok } = useUserRoles();
  const { data, loading } = useTiktokAdvertiserSummaryDataQuery({
    skip: !getToken() || !isAdvertiserFromTikTok
  });

  return { summaryData: data?.tiktokAdvertiserSummaryData, loading };
};
